// extracted by mini-css-extract-plugin
export var content = "Scores-module--content--a118f";
export var contentWrapper = "Scores-module--contentWrapper--8612f";
export var country = "Scores-module--country--2a7ae";
export var header = "Scores-module--header--573e1";
export var headerRow = "Scores-module--headerRow--135cb";
export var name = "Scores-module--name--ac117";
export var option = "Scores-module--option--747d4";
export var rank = "Scores-module--rank--63908";
export var row = "Scores-module--row--498fe";
export var rowOptions = "Scores-module--rowOptions--df3e9";
export var score = "Scores-module--score--04f51";
export var scoreRow = "Scores-module--scoreRow--494cb";
export var submit = "Scores-module--submit--76779";
export var submitButton = "Scores-module--submitButton--3ab11";
export var title = "Scores-module--title--91d31";
export var titleRow = "Scores-module--titleRow--00828";
export var winner = "Scores-module--winner--8efea";
export var wrapper = "Scores-module--wrapper--e30e6";